import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import React, { useEffect, useState } from 'react'
ChartJS.register(ArcElement, Tooltip, Legend)

import { Col, Row } from 'antd'
import {
  AlertTextDiv,
  ChartContainer,
  CustomDoughnut,
  IndividualCardDiv,
  LegendAnswerDiv,
  LegendContainer,
  LegendDiv,
  LegendDot,
  LegendTabDiv,
  LineHeight,
  LineHeightLegend,
  NoteMessageDiv,
  StaticData,
  StyledInfoCircles,
  StyledSpaceDiv,
} from './style'

const MandatoryIndex = ({ chartData }) => {
  const [clickedColor, setClickedColor] = useState({
    value: '',
    backgroundColor: '#09093F',
  })
  const [clickedColorForNonMandatory, setClickedColorForNonMandatory] =
    useState({
      value: '',
      backgroundColor: '#09093F',
    })
  const [mandatory, setMandatory] = useState(false)
  const [nonMandatory, setNonMandatory] = useState(false)
  const backgroundColor = [
    '#09093F',
    '#F75B02',
    '#F7B400',
    '#87BDFF',
    '#821B61',
    '#02E8F7',
    '#1A1980',
    '#F40E95',
    '#9118AF',
    '#95501E',
  ]

  const createLegendItem = (item, index) => {
    const color = backgroundColor[index % backgroundColor?.length]

    return (
      <li
        key={item}
        style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}
      >
        <LegendDot color={color} onClick={() => handleLegendItemClick(color)} />
        <LineHeightLegend>{item}</LineHeightLegend>
      </li>
    )
  }

  const handleLegendItemClick = color => {}

  const legendItems = chartData?.mandatory?.map(
    item => `${item?.noOfQuestions} Qs - ${item?.percentage}%`
  )
  const legendNonMandatoryItems = chartData?.nonMandatory?.map(
    item => `${item?.noOfQuestions} Qs - ${item?.percentage}%`
  )
  const dataItemsMandatory = chartData?.mandatory?.map(
    item => item?.studentCount
  )
  const mandatoryCount = chartData?.mandatory?.map(item => item?.noOfQuestions)
  const nonMandatoryCount = chartData?.nonMandatory?.map(
    item => item?.noOfQuestions
  )
  const mandatorySum = dataItemsMandatory?.reduce(
    (acc, currentValue) => Number(acc) + Number(currentValue),
    0
  )
  const dataItemsNonMandatory = chartData?.nonMandatory?.map(
    item => item?.studentCount
  )
  const nonMandatorySum = dataItemsNonMandatory?.reduce(
    (acc, currentValue) => Number(acc) + Number(currentValue),
    0
  )
  useEffect(() => {
    if (mandatoryCount?.[0] == 0) {
      setMandatory(true)
    }
  }, [mandatoryCount])
  useEffect(() => {
    if (nonMandatoryCount?.[0] == 0) {
      setNonMandatory(true)
    }
  }, [nonMandatoryCount])
  const dataMandatory = {
    datasets: [
      {
        borderWidth: 0,
        borderColor: '#CCCFD6',
        cutout: '60%',
        data: dataItemsMandatory,
        backgroundColor: [
          '#09093F',
          '#F75B02',
          '#F7B400',
          '#87BDFF',
          '#821B61',
          '#02E8F7',
          '#1A1980',
          '#F40E95',
          '#9118AF',
          '#95501E',
        ],
        hoverBackgroundColor: [
          '#09093F',
          '#F75B02',
          '#F7B400',
          '#87BDFF',
          '#821B61',
          '#02E8F7',
          '#1A1980',
          '#F40E95',
          '#9118AF',
          '#95501E',
        ],
      },
    ],
  }
  const dataNonMandatory = {
    datasets: [
      {
        borderWidth: 0,
        borderColor: '#CCCFD6',
        cutout: '60%',
        data: dataItemsNonMandatory,
        backgroundColor: [
          '#09093F',
          '#F75B02',
          '#F7B400',
          '#87BDFF',
          '#821B61',
          '#02E8F7',
          '#1A1980',
          '#F40E95',
          '#9118AF',
          '#95501E',
        ],
        hoverBackgroundColor: [
          '#09093F',
          '#F75B02',
          '#F7B400',
          '#87BDFF',
          '#821B61',
          '#02E8F7',
          '#1A1980',
          '#F40E95',
          '#9118AF',
          '#95501E',
        ],
      },
    ],
  }
  const optionMandatory = {
    maintainAspectRatio: false,

    plugins: {
      legend: false,
      tooltip: false,
      datalabels: {
        display: false,
      },
    },

    onHover: (event, elements) => {
      if (elements?.length > 0) {
        const activePoint = elements?.[0]
        const datasetIndex = activePoint?.datasetIndex
        const index = activePoint?.index
        const value = dataMandatory?.datasets?.[datasetIndex]?.data?.[index]
        const backgroundColor =
          dataMandatory?.datasets?.[0]?.backgroundColor?.[index]
        setMandatory(mandatoryCount?.[index] == 0)
        setClickedColor({ value: value, backgroundColor: backgroundColor })
      } else {
        setMandatory(false)
        setClickedColor({ value: '', backgroundColor: '#09093F' })
      }
    },
    onClick: (_, elements) => {
      if (elements.length > 0) {
        const clickedLabelIndex = elements[0].index
        const color =
          dataMandatory.datasets[0].backgroundColor[clickedLabelIndex]
        handleLegendItemClick(color)
      }
    },
  }
  const optionsNonMandatory = {
    maintainAspectRatio: false,

    plugins: {
      legend: false,
      tooltip: false,
      datalabels: {
        display: false,
      },
    },

    onHover: (event, elements) => {
      if (elements?.length > 0) {
        const activePoint = elements?.[0]
        const datasetIndex = activePoint?.datasetIndex
        const index = activePoint?.index
        const value = dataNonMandatory?.datasets?.[datasetIndex]?.data?.[index]
        const backgroundColor =
          dataNonMandatory?.datasets?.[0]?.backgroundColor?.[index]
        setClickedColorForNonMandatory({
          value: value,
          backgroundColor: backgroundColor,
        })
        setNonMandatory(nonMandatoryCount?.[index] == 0)
      } else {
        setMandatory(false)
        setClickedColorForNonMandatory({
          value: '',
          backgroundColor: '#09093F',
        })
      }
    },
    onClick: (_, elements) => {
      if (elements.length > 0) {
        const clickedLabelIndex = elements[0].index
        const color =
          dataNonMandatory.datasets[0].backgroundColor[clickedLabelIndex]
        handleLegendItemClick(color)
      }
    },
  }
  const firstMandatoryValue = chartData?.mandatory?.find(
    item => item.studentCount
  )
  const firstNonMandatoryValue = chartData?.nonMandatory?.find(
    item => item.studentCount
  )

  return (
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
        lg: 32,
      }}
    >
      {chartData?.totalMandatoryCandCount > 0 && (
        <Col className="gutter-row" span={12} md={12}>
          <IndividualCardDiv width={chartData?.totalNonMandatoryCandCunt == 0}>
            <Row>
              <Col
                className="gutter-row"
                xs={24}
                sm={24}
                md={18}
                lg={18}
                xl={18}
              >
                <ChartContainer>
                  <NoteMessageDiv mandatory={true}>
                    <StyledSpaceDiv mandatory={true}>
                      <StyledInfoCircles mandatory={true} />

                      <AlertTextDiv mandatory={true}>
                        {' '}
                        <span>
                          <div style={{ display: 'flex' }}>
                            <div>
                              {' '}
                              {mandatorySum} Candidates responded for the
                            </div>
                            <div
                              style={{
                                fontWeight: '800',
                                paddingLeft: '3px',
                                paddingRight: '3px',
                              }}
                            >
                              {' '}
                              Mandatory{' '}
                            </div>
                            question
                          </div>
                        </span>
                      </AlertTextDiv>
                    </StyledSpaceDiv>
                  </NoteMessageDiv>
                  <div style={{ height: '100%', width: '100%' }}>
                    <CustomDoughnut
                      data={dataMandatory}
                      options={optionMandatory}
                    />
                  </div>
                </ChartContainer>
              </Col>
              <Col
                className="gutter-row"
                xs={24}
                sm={24}
                md={6}
                lg={6}
                xl={6}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div>
                  <LegendContainer>
                    <StaticData>
                      <LineHeight
                        style={{
                          backgroundColor: clickedColor?.backgroundColor,
                        }}
                      >
                        {mandatory ? (
                          <>
                            {clickedColor?.value ||
                              firstMandatoryValue?.studentCount}{' '}
                            Candidates answered all questions incorrectly
                          </>
                        ) : (
                          <>
                            {clickedColor?.value ||
                              firstMandatoryValue?.studentCount}{' '}
                            Candidates answered correctly
                          </>
                        )}
                      </LineHeight>

                      <LegendTabDiv>
                        <LegendDiv> Legend</LegendDiv>
                        <LegendAnswerDiv> Answered Right</LegendAnswerDiv>
                      </LegendTabDiv>

                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {legendItems?.map((item, index) =>
                          createLegendItem(item, index)
                        )}
                      </ul>
                    </StaticData>
                  </LegendContainer>
                </div>
              </Col>
            </Row>
          </IndividualCardDiv>
        </Col>
      )}
      {chartData?.totalNonMandatoryCandCunt > 0 && (
        <Col className="gutter-row" span={12} md={12}>
          <IndividualCardDiv width={chartData?.totalMandatoryCandCount == 0}>
            <Row>
              <Col
                className="gutter-row"
                xs={24}
                sm={24}
                md={18}
                lg={18}
                xl={18}
              >
                <ChartContainer>
                  <NoteMessageDiv>
                    <StyledSpaceDiv>
                      <StyledInfoCircles />

                      <AlertTextDiv>
                        <span>
                          <div style={{ display: 'flex' }}>
                            <div>
                              {' '}
                              {nonMandatorySum} Candidates responded for the
                            </div>
                            <div
                              style={{
                                fontWeight: '800',
                                paddingLeft: '3px',
                                paddingRight: '3px',
                              }}
                            >
                              {' '}
                              Non Mandatory{' '}
                            </div>
                            question
                          </div>
                        </span>
                      </AlertTextDiv>
                    </StyledSpaceDiv>
                  </NoteMessageDiv>
                  <div style={{ height: '100%', width: '100%' }}>
                    <CustomDoughnut
                      data={dataNonMandatory}
                      options={optionsNonMandatory}
                    />
                  </div>
                </ChartContainer>
              </Col>
              <Col
                className="gutter-row"
                xs={24}
                sm={24}
                md={6}
                lg={6}
                xl={6}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <LegendContainer>
                  <StaticData>
                    <LineHeight
                      style={{
                        backgroundColor:
                          clickedColorForNonMandatory?.backgroundColor,
                      }}
                    >
                      {nonMandatory ? (
                        <>
                          {clickedColorForNonMandatory?.value ||
                            firstNonMandatoryValue?.studentCount + ' '}{' '}
                          Candidates answered all questions incorrectly
                        </>
                      ) : (
                        <>
                          {clickedColorForNonMandatory?.value ||
                            firstNonMandatoryValue?.studentCount}{' '}
                          Candidates answered correctly
                        </>
                      )}
                    </LineHeight>

                    <LegendTabDiv>
                      <LegendDiv> Legend</LegendDiv>
                      <LegendAnswerDiv> Answered Right</LegendAnswerDiv>
                    </LegendTabDiv>

                    <ul style={{ listStyle: 'none', padding: 0 }}>
                      {legendNonMandatoryItems?.map((item, index) =>
                        createLegendItem(item, index)
                      )}
                    </ul>
                  </StaticData>
                </LegendContainer>
              </Col>
            </Row>
          </IndividualCardDiv>
        </Col>
      )}
    </Row>
  )
}

export default MandatoryIndex
